exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " .timer {\n   text-align: center;\n   letter-spacing: -1px;\n   color: rgb(125, 0, 0);\n }\n\n .timer span {\n   font-size: 20px;\n }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-countdown/bra-countdown.component.css
// module id = ../../../../../src/app/componentes/bra-countdown/bra-countdown.component.css
// module chunks = main